<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <!-- <el-image v-if="swiperList && swiperList.length!=0"
              style="width:100%;height:463px;"
              :src="swiperList[0].resourceUrl"
              alt=""></el-image> -->
    <div class="currency_box box">
      <div class="left_content">
        <div class="title font32">
          <div class="logo">
            <img style="width:100%;height:100%"
                 :src="logo"
                 alt="">
          </div>
          <div>{{title}}</div>
        </div>
        <div class="content font24">{{content}}</div>
        <div class="list">
          <div class="item font14"
               v-for="(item,index) in list"
               :key="index">{{item}}</div>
        </div>
        <div class="imgList">
          <div class="imgItem"
               @mouseenter="mouseover(index)"
               @mouseleave="mouseout"
               v-for="(item,index) in  list2"
               :key="'i'+index">
            <div class="img">
              <div v-if="activeIndex!= index"
                   style="width:48px;height:48px">
                <el-image style="width:100%;height:100%"
                          :src="item.img1"
                          alt=""></el-image>
              </div>
              <div v-else
                   class="code">
                <el-image style="width:100%;height:100%"
                          :src="downImg"
                          alt=""></el-image>
              </div>
            </div>
            <div class="content">{{item.content}}</div>
          </div>
          <!-- <div class="imgItem">
            <div class="img"></div>
            <div class="content">IOS</div>
          </div> -->
        </div>
      </div>
      <div class="right_content">
        <el-image style="width:100%;height:100%"
                  :src="appDownImg"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import {
  resourceList
} from '@/api/api.js'
export default {
  data () {
    return {
      swiperList: [],
      data: {
        showIndex: 7,
        pageNumber: 1,
        pageSize: 100
      },
      logo: '',
      appDownImg: '', //下载介绍图
      activeIndex: -1,
      title: '零售视界｜APP下载',
      content: '零售人的加油站，零售人线上商学院',
      list: ['①、新用户免费领取7天会员权益', '②、提升个人创新和认知升级，锻造员工基本功', '③、挖掘企业人才，提升团队实战能力'],
      downImg: '',
      list2: [
        {
          content: 'Android',
          img1: 'https://commonresource-1252524126.cdn.xiaoeknow.com/image/l88thhn30wkv.png',
        },
        {
          content: 'ios',
          img1: 'https://commonresource-1252524126.cdn.xiaoeknow.com/image/l88thg7x0zt1.png'
        }
      ]
    }
  },
  created () {
    this.getresourceList(7)
    this.getresourceList(14)
    this.getresourceList(16)
    this.getresourceList(21)
  },
  methods: {
    async getresourceList (type) {  //获取首页资源
      this.data.showIndex = type
      const res = await resourceList(this.data)
      if (type == 7) {
        this.swiperList = res.data;
      } else if (type == 14) {
        this.appDownImg = res.data[0].resourceUrl;
      } else if (type == 16) {
        this.downImg = res.data[0].resourceUrl;
      } else if (type == 21) {
        this.logo = res.data[0].resourceUrl;
      }
    },
    mouseover (index) {
      this.activeIndex = index;
    },
    mouseout () {
      this.activeIndex = -1;
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  background-color: #fff;
  .box {
    min-width: 1200px;
    padding-top: 130px;
    background-color: #fff;
    padding-bottom: 30px;
    box-sizing: border-box;
    .left_content {
      flex: 1;
      .title {
        display: flex;
        color: #333;
        font-weight: bold;
        align-items: center;
        .logo {
          width: 56px;
          height: 56px;
          background-color: #fff;
          margin-right: 20px;
        }
      }
      .content {
        margin: 20px 0 20px 0;
        color: #333;
        font-weight: bold;
      }
      .list {
        .item {
          display: flex;
          color: #333;
          margin-bottom: 20px;
          font-weight: bold;
        }
      }
      .imgList {
        margin-top: 10px;
        display: flex;
        .imgItem {
          width: 132px;
          margin-right: 40px;
          text-align: center;
          .img {
            width: 100%;
            height: 132px;
            margin-bottom: 10px;
            border-radius: 10px;
            background-color: #fff;
            box-shadow: 0px 5px 6px 0px rgba(51, 51, 51, 0.27);
            display: flex;
            justify-content: center;
            align-items: center;
            .code {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
    .right_content {
      width: 678px;
      background-color: #fff;
      height: 424px;
    }
  }
}
</style>
